const overlay = document.getElementById('overlay') as HTMLElement;
const panel = document.getElementById('panel') as HTMLElement;

export function showLoading(): void {
  overlay.hidden = false;
  overlay.innerHTML = '<div class="spinner"></div>';
}

export function hideLoading(): void {
  overlay.hidden = true;
}

/** Terminal state: a blank canvas is confusing, a big "tap to restart" is not. */
export function showFatal(message: string): void {
  overlay.hidden = false;
  overlay.innerHTML = '';
  const text = document.createElement('p');
  text.textContent = message;
  const button = document.createElement('button');
  button.textContent = 'Tap to restart';
  button.style.cssText =
    'font:inherit;color:inherit;background:#ffffff1a;border:1px solid #ffffff33;border-radius:12px;padding:1rem 1.6rem;min-height:52px';
  button.addEventListener('click', () => location.reload());
  overlay.append(text, button);
}

export type StyleFlag = 'jitter' | 'affine';

export interface PanelHandlers {
  onResetView(): void;
  onToggleFlag(flag: StyleFlag, on: boolean): void;
  stats(): { drawCalls: number; triangles: number; buffer: string };
}

/**
 * The hidden adult panel: reset the view, flip the two optional styling effects,
 * and read the render cost. Nothing destructive lives behind it.
 */
export function buildPanel(handlers: PanelHandlers): { open(): void } {
  const flags: Record<StyleFlag, boolean> = { jitter: false, affine: false };
  const labels: Record<StyleFlag, string> = {
    jitter: 'Vertex wobble',
    affine: 'Texture warp',
  };

  const close = () => {
    panel.hidden = true;
  };

  const render = () => {
    panel.innerHTML = '';

    for (const flag of Object.keys(flags) as StyleFlag[]) {
      const button = document.createElement('button');
      button.textContent = labels[flag];
      button.setAttribute('aria-pressed', String(flags[flag]));
      button.addEventListener('click', () => {
        flags[flag] = !flags[flag];
        handlers.onToggleFlag(flag, flags[flag]);
        button.setAttribute('aria-pressed', String(flags[flag]));
      });
      panel.append(button);
    }

    const reset = document.createElement('button');
    reset.textContent = 'Reset view';
    reset.addEventListener('click', () => {
      handlers.onResetView();
      close();
    });

    const back = document.createElement('button');
    back.textContent = 'Close';
    back.addEventListener('click', close);

    const { drawCalls, triangles, buffer } = handlers.stats();
    const info = document.createElement('div');
    info.className = 'version';
    info.textContent = `${buffer} · ${drawCalls} draws · ${triangles} tris · build ${__BUILD_ID__}`;

    panel.append(reset, back, info);
  };

  return {
    open() {
      render();
      panel.hidden = false;
    },
  };
}
